import React, { useState } from 'react';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';

import SpotlioIcon from '../../components/Icon';

import './ToggleGroup.scss';

export default (props) => {
    const [ selected, setSelected ] = useState('list');

    const toggleSelected = (selected) => {
        setSelected(selected);
        if (selected === 'list') {
            props.setListValue(!props.displayList)
        } if (selected === 'map') {
            props.setMapValue(!props.displayMap)
        }
    }

    if (props.displayMap && selected !== 'map'){
        setSelected('map');
    }
    if (props.displayList && selected !== 'list') {
        setSelected('list');
    }

    return (
        <ToggleButtonGroup value={selected} exclusive className="viewOptions">
            <ToggleButton value="list" onClick={()=> selected === 'map' && toggleSelected('list')} className="option">
                <SpotlioIcon icon={"feather-list"} size={16} />
                <span className="label">List</span>
            </ToggleButton>
            <ToggleButton value="map" onClick={()=> selected === 'list' && toggleSelected('map')} className="option">
                <SpotlioIcon icon={"feather-map-pin"} size={16} />
                <span className="label">Map</span>
            </ToggleButton>
        </ToggleButtonGroup>
    );
}
